angular.module('taric.moreinfo.codelists.view', ['taric.model.codelists', 'common.helper', 'common.filter.specialCharacterToHtml', 'common.filter.description'])
    .controller('ViewCodelistsController', function (codeTypeChildren, CodeListsModel, simulationDate, showCancelButton, $uibModal, $uibModalInstance, $state, CONSTANTS, CommonHelper, $filter, $rootScope, $scope, $timeout) {
        var viewCodelistsCtrl = this;
        viewCodelistsCtrl.selectedRow = codeTypeChildren;
        viewCodelistsCtrl.viewCodelistsResult = null;
        viewCodelistsCtrl.viewCriteria = CodeListsModel.getSearchCriteria();
		viewCodelistsCtrl.numberOfColumn = 2;
    	
        if (viewCodelistsCtrl.selectedRow !== null) {
            viewCodelistsCtrl.dateFormat = CONSTANTS.dateFormat;
            viewCodelistsCtrl.itemsPerPage =  CONSTANTS.rowsPerPage;
            viewCodelistsCtrl.showCancelButton = showCancelButton;
            viewCodelistsCtrl.selectedCodelist = CodeListsModel.getSelectedCodelist();
        }

		if (viewCodelistsCtrl.selectedCodelist.codeTypeId === 'ADD' && viewCodelistsCtrl.selectedCodelist.type === '7'){
			viewCodelistsCtrl.selectedRow.totalItems = -1;
			viewCodelistsCtrl.selectedRow.infoMessage = "i8n.qry.cl.queryCodeListViewBean.adcoType7_detail";
		}

		if (viewCodelistsCtrl.selectedCodelist.codeTypeId === 'ADD' && viewCodelistsCtrl.selectedCodelist.type === '9'){
			viewCodelistsCtrl.numberOfColumn = 3;
		}

        viewCodelistsCtrl.resetViewCodelistsResult = function() {
            viewCodelistsCtrl.selectedRow = null;
            CodeListsModel.resetViewResult();
        };

        // Load data for a given page
        viewCodelistsCtrl.loadDataFromServer = function(pageNumber) {
            // Reset view result before searching
            viewCodelistsCtrl.resetViewCodelistsResult();

            viewCodelistsCtrl.searching = true;
            CodeListsModel.queryCodeTypeChildren(pageNumber).then(function(selectedRow) {
                viewCodelistsCtrl.selectedRow = selectedRow;
                viewCodelistsCtrl.searching = false;
            }, function(error){
                viewCodelistsCtrl.errorCode = error.data.code;
                viewCodelistsCtrl.errorParams = error.data.params;
                viewCodelistsCtrl.searching = false;
            });
        };

        // Handle page change for the codelists view result table
        viewCodelistsCtrl.viewCodelistsResultPageChanged = function (pageNumber) {
            viewCodelistsCtrl.loadDataFromServer(pageNumber);
        };

        // export excel
        viewCodelistsCtrl.exportExcel = function() {
        	
          	$rootScope.$broadcast('startSpinningExport');
          	
          	// query all the data without pagination in the database
          	CodeListsModel.queryCodeTypeChildren().then(function(selectedRow) {

          		// extract dates from html
            	var reportDate = $filter('date')(new Date(), CONSTANTS.dateTimeFormat);
            	viewCodelistsCtrl.selectedAllRow = selectedRow;
            	document.getElementById('reportDateExtr').innerHTML = reportDate;
            	
            	// wait 1s for front end to render
            	setTimeout(function(){

            		var columnLength = document.getElementById('exportExcelTable').rows[4].cells.length;
                	var title = $filter('description')(viewCodelistsCtrl.selectedCodelist.descriptions);
                	
                	// column length format of excel
                	var ws = {
                		'!cols': [{
                			wpx: 180
                		}, {
                			wpx: 550
                		}, {
                			wpx: 250
                		}]
                	};

              		if (columnLength > 2) {

              			ws = {
              				'!cols': [{
                        		wpx: 180
                        	}, {
                        		wpx: 250
                        	}, {
                        		wpx: 550
                        	}, {
                        		wpx: 150
                        	}]
              			};
              		}
              		
              		// because this report is special, it has its own format function
                	CommonHelper.printExcel("exportExcelTable", title, ws, function(cell, R, C) {
                		
                		// R is row and C is column
                		// some cells in this report has special formats
                		if (R === 0 && C === 0) {
        					cell.s = {
            						font: {
            							name: CONSTANTS.printableFont,
            							bold: true,
                						sz: 12
            						},
            						alignment: {
            							horizontal: "center"
            						}
            				};
        				} else if ((R === 1 || R === 2) && C === 0) {
        					cell.s = {
            						font: {
            							name: CONSTANTS.printableFont,
            							bold: true,
                						sz: 12
            						},
            						alignment: {
            							horizontal: "left"
            						}
            				};
        				} else if (R === 0 && C > 0) {
        					cell.s = {
            						font: {
            							name: CONSTANTS.printableFont,
            							bold: true
            						},
            						alignment: {
            							horizontal: "right"
            						}
            				};
        				} else if (R === 4) {
        					cell.s = {
        							font: {
            							name: CONSTANTS.printableFont,
            							bold: true,
                						sz: 11
            						},
            						alignment: {
            							horizontal: "center"
            						},
        							border: {
        				                top: { style: "thin", color: {rgb: "000000"}}
        							}
            				};
        				} else if (R > 4) {
        					cell.s = {
            					font: {
        							name: CONSTANTS.printableFont,
            						sz: 10
            					},
        						alignment: {
        							wrapText: 1,
        							horizontal: "left"
        						}
            				};
        					
        					if (C < 2 && columnLength > 2)
        						cell.s.alignment = { horizontal: "center" };
        					else if (C === 0)
            					cell.s.alignment = { horizontal: "center" };
            			}
                	}).then(() => {
                        $rootScope.$broadcast('stopSpinningExport');
                    }, () => {
                        $rootScope.$broadcast('stopSpinningExport');
                    });
            	}, 1000);
            	
            }, function(error){
                
            	// show errors here
              	$rootScope.$broadcast('stopSpinningExport');
            });
        };
        
        // print pdf
        viewCodelistsCtrl.print = function(options) {
          	$rootScope.$broadcast('startSpinningPrint');

			// query all the data without pagination in the database
			CodeListsModel.queryCodeTypeChildren().then(function(selectedRow) {

				var items = [];

				// If description is long, this method is used to break the long description into multiple rows
				angular.forEach(selectedRow.codeTypeChildrenResult, function(codeTypeChildrenResult){

					var description = $filter('description')(codeTypeChildrenResult.descriptions, viewCodelistsCtrl.viewCriteria.language);
					description = $filter('specialCharacterToHtml')(description);

					// the limit is 1689 characters. it is the number of characters that a row can have before it overlaps footer
					if (description && description.length > 1689) {
						var desc1 = description.substring(0, 1689);
						var desc2 = description.substring(1689);

						// this is used to maintain breaking line after trimming. We dont want to see a half-break word here
						var lastDot = desc2.indexOf("<br>");
						codeTypeChildrenResult.descriptions = desc1 + desc2.substring(0, lastDot + 4);

						items.push(codeTypeChildrenResult);
						items.push({descriptions: desc2.substring(lastDot + 4), code: '', additionalInformation: ''});

					} else {

						codeTypeChildrenResult.descriptions = description;
						items.push(codeTypeChildrenResult);
					}
				});
				viewCodelistsCtrl.selectedAllRow = items;

				// wait 1s before rendering
				setTimeout(function(){

					// load documents
					var doc = [];
					CommonHelper.htmlTableToPdf(doc, document.getElementById('exportBodyTable'), options);

					// Only print view result table when there are data.
					if (viewCodelistsCtrl.selectedAllRow.length > 0) {
						doc.push ({ text: '\n' });
						CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);
					}

					CommonHelper.printPlainDocument({
						contents: doc,
						logo: options.logo,
						validDate: $filter('date')(simulationDate, CONSTANTS.dateFormat),
						title: $filter('description')(viewCodelistsCtrl.selectedCodelist.descriptions)
					}, 'p').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });
				}, 1000);

			}, function (error) {
				viewCodelistsCtrl.errorCode = error.data.code;
				viewCodelistsCtrl.errorParams = error.data.params;
				$rootScope.$broadcast('stopSpinningPrint');
			});
        };

    	$scope.$on('printDocument', function(event, data) {
    		
    		CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, viewCodelistsCtrl.print, true);
        });

    	$scope.$on('exportDocument', function(event, data) {
    		
    		viewCodelistsCtrl.exportExcel();
        });

		$rootScope.$on('$translateChangeSuccess', function () {

			//This is just a workaround to force the page to re-render the pagination items with translated texts
			viewCodelistsCtrl.itemsPerPage = 99999999;
			$timeout(function(){
				viewCodelistsCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
			}, 100);
		});
    	
    });



// WEBPACK FOOTER //
// ./app/taric/moreinfo/codelists/view/codelists-view.js